var map = {
	"./logical-reasoning/exam.json": "2629",
	"./mechanical-reasoning/exam.json": "2137",
	"./numerical-reasoning/exam.json": "546a",
	"./situational-judgement/exam.json": "22ab",
	"./verbal-reasoning/exam.json": "9411"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "73c7";